var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.pdsList),function(pds,index){return _c('div',{key:index},[(pds.token == 'invalid' )?_c('div',[_c('accountNotFoundModal',{attrs:{"pds":pds.pds}})],1):_vm._e()])}),(_vm.pdsList)?_c('ProfessionalDashboardWidget',{attrs:{"pdsList":_vm.pdsList}}):_c('div',[_c('spinner')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }